import { logger } from "logging";
import { reportWebVitals } from "./monitoring.report-web-vitals";

export function setupMonitoring() {
  reportWebVitals(logger.info);
}
